






























import { Component, Prop, Vue } from 'vue-property-decorator';
import CoinIcon from '@/components/icons/WidgetCoin.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import flagKeys from '@/constants/flagKeys';

@Component({
  components: {
    CoinIcon,
    Typography
  }
})
export default class BillingNetworkTag extends Vue {
  @Prop({ default: '' }) featureName!: string;

  get flags() {
    return this.$store.getters['flags/getFlags'];
  }

  get slug() {
    return this.featureName
      .toLocaleLowerCase()
      .split(' ')
      .join('-');
  }

  get isNotFeature() {
    const notFeatureRoutes = ['/coin-network-plan'];

    return notFeatureRoutes.includes(this.$route.path);
  }

  get showBillingTag() {
    return this.flags.includes(flagKeys.billingModuleV2);
  }
}
